<template>
	<el-container>
		<!-- <el-header class="greenmenu">
			<span @click="$router.back(-1)" class="backstr">
				<返回</span> <span class="header_h2">预约提醒
			</span>
		</el-header> -->
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="tomain()" :src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="tomain()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">预约提醒 </span>
		</el-header>
		<el-row type="flex" justify="center">
			<!-- <el-tabs  v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="未约信息" name="tab1"> -->
			<div :style="{width:$myglobal.screenwidth+'px'}">
				<el-row style="margin-top: 10px;">
					<el-col :span="24">
						<img src='/img/webimg/booksuccess.png'>
					</el-col>
				</el-row>
				<el-row style="height: 100px;">
					<el-col :span="24">
						<!-- 感谢您使用在线预约平台 -->
						<span class="spanbig"> 预约成功!</span>
					</el-col>
					<el-button style="width: 90%;font-size: 20px;" type="primary" @click="tobooked">查看预约明细</el-button>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<checknotice></checknotice>
					</el-col>
				</el-row>

				

			</div>
		</el-row>
	</el-container>
</template>

<script>
	import checknotice from './CheckNotice.vue'
	export default {
		created() {
			this.mobile = this.$route.query.mobile;
		},
		components:{
			checknotice
		},
		data() {
			return {
				mobile: ''
			}
		},
		methods: {
			tobooked() {
				var data = {
					path: '/BookedCusList',
					query: {
						mobile: this.mobile
					}
				}
				this.$router.push(data)
			},
			tomain() {
				var data = {
					path: '/mainbook',
					query: {
						mobile: this.mobile,
						showmenu:true
					}
				
				}
				this.$router.push(data)
			},
		}
	}
</script>

<style>
</style>
